import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { TGetTransactionBankBuySerialNumberDetailsBatchParams, TGetTransactionBankBuySerialNumberDetailsParams } from '~types/feat/gold'; // adjust path to wherever this type lives
import { PayloadAction } from '@reduxjs/toolkit';

export default function* watchGetTransactionBankBuySerialNumberDetails(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetTransactionBankBuySerialNumberDetailsAttempt', handleGetTransactionBankBuySerialNumberDetails, api);
}

function* handleGetTransactionBankBuySerialNumberDetails(
    api: GoldGateway,
    action: PayloadAction<TGetTransactionBankBuySerialNumberDetailsBatchParams>
) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    for (const { serialNo, productId, customerId } of action.payload) {
        const response = yield* call([api, api.getTransactionBankBuySerialNumberDetails], {
            authToken,
            serialNo,
            productId,
            customerId,
        });

        if (response.status === GatewayResponseStatus.Error) {
            yield put(combinedActions.goldGetTransactionBankBuySerialNumberDetailsFailure(response.message || ErrorMessages.GenericError));
            toast.error(response.message || ErrorMessages.GenericError);
            return;
        }
    }

    yield put(combinedActions.goldGetTransactionBankBuySerialNumberDetailsSuccess([]));
}
